import { ConfigProvider } from "antd";
import "./App.css";
import "./theme/shadcn.css";
import { RoutesComponent } from "./components/main/routes/RoutesComponent";
import { shadcnTheme } from "./theme/shadcnTheme";

function App() {
  return (
    <ConfigProvider theme={shadcnTheme}>
      <RoutesComponent />
    </ConfigProvider>
  );
}

export default App;
